export default __webpack_public_path__ + "static/media/heavyrain.7c9f049d.svg";